<template>
  <div class="hlj-header" :style="`background-color: ${backColor}`">
    <div class="header-content">
      <div class="hlj-logo">
        <img v-if="schoolInfo" :src="schoolInfo.school_logo_light" alt="">
        <div class="header-title" @click="$router.push(`/${school_code}/custom/hljdypx`)">党员培训学习平台</div>
      </div>
      <div class="header-nav">
        <div class="nav-item" @click="toLink(`/user/myClass`)">我的课程</div>
        <div class="nav-item" @click="toLink(`/user/studyRecord`)">学习记录</div>
        <div class="nav-item" @click="toLink(`/user/MyStudy`)">学习数据</div>
      </div>
      <div class="header-right">
        <a href="https://www.hnyjj.org.cn/" target="_blank" class="school-link">学校主页</a>
        <div :class="['eol-right-user', menuOpen ? 'up' : 'down']" @mouseleave="menuOpen = false"
          @click="menuOpen = !menuOpen">
          <div class="login-btn" v-if="!loginUserInfo || loginUserInfo.school_code != school_code"
            @click="handleLogin()">登录</div>
          <template v-else>
            <div class="mine-lines">
              <!-- <div class="user-imgs-box"></div> -->
              <span>{{ loginUserInfo && loginUserInfo.name ? loginUserInfo.name : loginUserInfo &&
                loginUserInfo.username }}</span>
            </div>
            <ul @mouseleave="menuOpen = false" class="eol-submine-box">
              <template v-if="services.DEPLOY !== 'hzvtc'">
                <li class="submine-items">
                  <a :href="`${services.LOGIN_SERVER}/${school_code}/worker`">信息服务中心</a>
                </li>
                <li class="submine-items">
                  <a :href="`${services.LOGIN_SERVER}/${school_code}/userInfo`">个人信息</a>
                </li>
                <li class="submine-items">
                  <a :href="`${services.LOGIN_SERVER}/${school_code}/editPassword`">修改密码</a>
                </li>
              </template>
              <li class="submine-items" @click="logoutEvents">
                <a href="javascript:;">退出登录</a>
              </li>
            </ul>
          </template>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import services from '../../../config/services';
import { mapState, mapActions } from 'vuex';
import { Message } from "ant-design-vue"
import utils from '../../../config/utils';
export default {
  props: {
    backColor: {
      default: "",
      type: String
    }
  },
  async created() {
    await this.getAppsLoginUserInfo()
    this.getLoginSchoolInfo({ school_code: this.school_code }).then(res => {
      if (res.code == '0000') utils.setTitle(document.title + "-" + res.data.school_name)
    });
  },
  data() {
    return {
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      services,
      menuOpen: false,
    }

  },
  methods: {
    ...mapActions(["requestAppsLogout", 'getAppsLoginUserInfo', "getLoginSchoolInfo"]),
    // 点击登录
    handleLogin() {
      window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${this.school_code}&from=${window.location.href}`, "_self")
    },
    // 退出登录
    logoutEvents() {
      if (window.location.href.indexOf("hzvtc/detail") > -1) {
        localStorage.setItem("eol-hzvtc-detail-key", this.$route.query.key)
      }
      this.requestAppsLogout()
    },
    toLink(to) {
      let link = this.$router.resolve({
        path: `/${this.school_code}${to}`,
      })
      window.open(link.href, "_blank")
    }
  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
      schoolInfo: (state) => state.appsLogin.schoolInfo,
    }),
  },
}
</script>
<style lang="less" scoped>
.hlj-header {
  height: 0.8rem;
  display: flex;
  justify-content: center;

  .header-content {
    height: 0.8rem;
    width: 12rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .hlj-logo {
      max-height: 0.42rem;
      display: flex;
      align-items: center;

      .header-title {
        font-weight: bold;
        font-size: 0.2rem;
        padding-left: 0.14rem;
        color: #ffffff;
        cursor: pointer;

        &::before {
          content: "";
          width: 1px;
          height: 19px;
          background: #ffffff;
          opacity: 0.4;
          display: inline-block;
          vertical-align: -0.02rem;
          margin-right: 0.14rem;
        }
      }

      img {
        max-height: 0.42rem;
      }
    }

    .header-nav {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      margin-right: 0.38rem;

      .nav-item {
        font-weight: bold;
        font-size: 0.16rem;
        color: #fffac1;
        margin: 0.22rem;
        cursor: pointer;
      }
    }

    .header-right {
      display: flex;

      .school-link {
        font-weight: bold;
        font-size: 0.16rem;
        color: #fffac1;
        margin-right: 0.6rem;
        display: block;

        &::before {
          content: "";
          display: inline-block;
          width: 0.18rem;
          height: 0.19rem;
          background-image: url("../../../assets/custom/hlj/index/school-icon.png");
          background-size: cover;
          background-position: center;
          vertical-align: -0.03rem;
          margin-right: 0.08rem;
        }
      }

      .eol-right-user {
        max-width: 2.6rem;
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;

        .login-btn {
          font-weight: bold;
          font-size: 0.16rem;
          color: #fffac1;
          cursor: pointer;

          &::before {
            content: "";
            display: inline-block;
            width: 0.18rem;
            height: 0.19rem;
            background-image: url("../../../assets/custom/hlj/index/user-icon.png");
            background-size: cover;
            background-position: center;
            vertical-align: -0.03rem;
            margin-right: 0.08rem;
          }
        }
      }

      .eol-right-user .close-page-box {
        position: absolute;
        display: inline-block;
        font-size: 0.16rem;
        color: #3a3a3a;
        display: inline-block;
        margin-left: 0.05rem;
        top: 0.13rem;
        left: -0.8rem;
        cursor: pointer;
      }

      .eol-right-user .close-page-box img {
        vertical-align: -0.04rem;
      }

      .eol-right-user .mine-lines {
        height: 100%;
        font-weight: bold;
        font-size: 0.16rem;
        color: #fffac1;
        cursor: pointer;
        display: flex;
        align-items: center;

        &::before {
          content: "";
          display: inline-block;
          width: 0.18rem;
          height: 0.19rem;
          background-image: url("../../../assets/custom/hlj/index/user-icon.png");
          background-size: cover;
          background-position: center;
          vertical-align: -0.03rem;
          margin-right: 0.08rem;
        }
      }

      .eol-right-user .mine-lines span {
        vertical-align: middle;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        max-width: 0.55rem;
        margin: 0 0.08rem 0 0.06rem;
      }

      .eol-right-user .mine-lines::after {
        content: "";
        display: inline-block;
        width: 0.12rem;
        height: 0.12rem;
        background-image: url("../../../assets/custom/party/index/menu-down.png");
        background-repeat: no-repeat;
        background-size: 100% auto;
        margin-left: 0.04rem;
      }

      .eol-right-user.up .mine-lines::after {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
        -webkit-transition: -webkit-transform 0.3s;
        transition: transform 0.3s;
      }

      .eol-right-user.down .mine-lines::after {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transition: -webkit-transform 0.3s;
        transition: transform 0.3s;
      }

      // .eol-right-user .user-imgs-box {
      //   display: inline-block;
      //   width: 0.20rem;
      //   height: 0.20rem;
      //   margin-right: 0.04rem;
      //   vertical-align: middle;
      //   text-align: right;
      //   background: url('../../../assets/custom/party/index/user.png')
      //     no-repeat center;
      //   background-size: 100% auto;
      // }

      .eol-right-user .eol-submine-box {
        background: #ffffff;
        border: 1px solid #dfe3e4;
        position: absolute;
        z-index: 1000;
        top: 100%;
        right: -0.12rem;
        padding: 0.18rem 0.15rem 0.18rem 0.2rem;
        text-align: left;
        display: none;
        min-width: 1.3rem;
      }

      .eol-right-user.up .eol-submine-box {
        display: block;
      }

      .eol-right-user.down .eol-submine-box {
        display: none;
      }

      .eol-right-user .submine-items {
        height: 0.3rem;
        color: #71737b;
        line-height: 0.3rem;
        font-size: 0.14rem;
        cursor: pointer;
      }

      .eol-right-user .submine-items a {
        display: block;
        width: auto;
        color: #71737b;
      }

      .eol-right-user .submine-items.active,
      .eol-right-user .submine-items:hover a {
        color: #3460e4;
        text-decoration: none;
      }

      .eol-right-user .mine-left-icons {
        width: 0.14rem;
        height: 0.14rem;
        margin-right: 0.06rem;
        display: inline-block;
        vertical-align: -0.02rem;
      }
    }
  }
}
</style>